import { RefObject, useEffect } from "react";

type handleClickProps = {
  ref: RefObject<HTMLDivElement>;
  outsideClickcallback?: () => void;
  insideClickcallback?: () => void;
};

export default function useHandleClickOutside({ ref, outsideClickcallback, insideClickcallback }: handleClickProps) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (!ref.current?.parentNode?.contains(event.target as Node)) {
        outsideClickcallback?.();
      }
      if (ref.current?.parentNode?.contains(event.target as Node)) {
        insideClickcallback?.();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [outsideClickcallback, insideClickcallback, ref]);
}
